import React from "react";
const UpIcon = () => (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("mask", { id: "mask0_4400_14458", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "17", height: "16" },
        React.createElement("rect", { x: "0.399902", width: "16", height: "16", fill: "#D9D9D9" })),
    React.createElement("g", { mask: "url(#mask0_4400_14458)" },
        React.createElement("path", { d: "M7.73307 13.3334V5.21675L3.99974 8.95008L3.06641 8.00008L8.39974 2.66675L13.7331 8.00008L12.7997 8.95008L9.06641 5.21675V13.3334H7.73307Z", fill: "#4B4F5E" }))));
const DownIcon = () => (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("mask", { id: "mask0_4400_24057", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "17", height: "16" },
        React.createElement("rect", { x: "0.199707", width: "16", height: "16", fill: "#D9D9D9" })),
    React.createElement("g", { mask: "url(#mask0_4400_24057)" },
        React.createElement("path", { d: "M7.53288 2.66675V10.7834L3.79954 7.05008L2.86621 8.00008L8.19954 13.3334L13.5329 8.00008L12.5995 7.05008L8.86621 10.7834V2.66675H7.53288Z", fill: "#4B4F5E" }))));
const DeleteIcon = () => (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M5.50063 14.0037C5.13384 14.0037 4.81975 13.873 4.55833 13.6116C4.29692 13.3502 4.16643 13.0363 4.16688 12.67V4.00062H3.5V2.66687H6.83437V2H10.8356V2.66687H14.17V4.00062H13.5031V12.67C13.5031 13.0368 13.3724 13.3509 13.111 13.6123C12.8496 13.8737 12.5357 14.0042 12.1694 14.0037H5.50063ZM6.83437 11.3362H8.16813V5.33437H6.83437V11.3362ZM9.50187 11.3362H10.8356V5.33437H9.50187V11.3362Z", fill: "#4B4F5E" })));
const CopyIcon = () => (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M4.67647 13.7647C4.35294 13.7647 4.07588 13.6494 3.84529 13.4188C3.61471 13.1882 3.49961 12.9114 3.5 12.5882V4.35294H4.67647V12.5882H11.1471V13.7647H4.67647ZM7.02941 11.4118C6.70588 11.4118 6.42882 11.2965 6.19824 11.0659C5.96765 10.8353 5.85255 10.5584 5.85294 10.2353V3.17647C5.85294 2.85294 5.96824 2.57588 6.19882 2.34529C6.42941 2.11471 6.70628 1.99961 7.02941 2H12.3235C12.6471 2 12.9241 2.1153 13.1547 2.34588C13.3853 2.57647 13.5004 2.85333 13.5 3.17647V10.2353C13.5 10.5588 13.3847 10.8359 13.1541 11.0665C12.9235 11.2971 12.6467 11.4122 12.3235 11.4118H7.02941Z", fill: "#4B4F5E" })));
const CancelIcon = () => (React.createElement("svg", { width: "17", height: "16", viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M8.50004 8.93325L10.4334 10.8666C10.5556 10.9888 10.7112 11.0499 10.9 11.0499C11.0889 11.0499 11.2445 10.9888 11.3667 10.8666C11.4889 10.7444 11.55 10.5888 11.55 10.3999C11.55 10.211 11.4889 10.0555 11.3667 9.93325L9.43337 7.99992L11.3667 6.06659C11.4889 5.94436 11.55 5.78881 11.55 5.59992C11.55 5.41103 11.4889 5.25547 11.3667 5.13325C11.2445 5.01103 11.0889 4.94992 10.9 4.94992C10.7112 4.94992 10.5556 5.01103 10.4334 5.13325L8.50004 7.06659L6.56671 5.13325C6.44449 5.01103 6.28893 4.94992 6.10004 4.94992C5.91115 4.94992 5.7556 5.01103 5.63337 5.13325C5.51115 5.25547 5.45004 5.41103 5.45004 5.59992C5.45004 5.78881 5.51115 5.94436 5.63337 6.06659L7.56671 7.99992L5.63337 9.93325C5.51115 10.0555 5.45004 10.211 5.45004 10.3999C5.45004 10.5888 5.51115 10.7444 5.63337 10.8666C5.7556 10.9888 5.91115 11.0499 6.10004 11.0499C6.28893 11.0499 6.44449 10.9888 6.56671 10.8666L8.50004 8.93325ZM8.50004 14.6666C7.57782 14.6666 6.71115 14.4915 5.90004 14.1413C5.08893 13.791 4.38337 13.3161 3.78337 12.7166C3.18337 12.1166 2.70849 11.411 2.35871 10.5999C2.00893 9.78881 1.83382 8.92214 1.83337 7.99992C1.83337 7.0777 2.00849 6.21103 2.35871 5.39992C2.70893 4.58881 3.18382 3.88325 3.78337 3.28325C4.38337 2.68325 5.08893 2.20836 5.90004 1.85859C6.71115 1.50881 7.57782 1.3337 8.50004 1.33325C9.42226 1.33325 10.2889 1.50836 11.1 1.85859C11.9112 2.20881 12.6167 2.6837 13.2167 3.28325C13.8167 3.88325 14.2918 4.58881 14.642 5.39992C14.9923 6.21103 15.1672 7.0777 15.1667 7.99992C15.1667 8.92214 14.9916 9.78881 14.6414 10.5999C14.2912 11.411 13.8163 12.1166 13.2167 12.7166C12.6167 13.3166 11.9112 13.7917 11.1 14.1419C10.2889 14.4921 9.42226 14.667 8.50004 14.6666Z", fill: "#FEFEFE" })));
export const ButtonList = (onUp, onDown, onDelete, onCopy, onCancel) => [
    {
        id: 'up-btn',
        label: '',
        icon: React.createElement(UpIcon, null),
        onClick: onUp,
    },
    {
        id: 'down-btn',
        label: '',
        icon: React.createElement(DownIcon, null),
        onClick: onDown,
    },
    {
        id: 'delete-btn',
        label: '',
        icon: React.createElement(DeleteIcon, null),
        onClick: onDelete,
    },
    {
        id: 'copy-btn',
        label: '',
        icon: React.createElement(CopyIcon, null),
        onClick: onCopy,
    },
    {
        id: 'cancel-btn',
        label: '',
        icon: React.createElement(CancelIcon, null),
        onClick: onCancel,
    },
];
export const ButtonListItem = (onUp, onDown, onDelete, onCancel) => [
    {
        id: 'up-btn',
        label: '',
        icon: React.createElement(UpIcon, null),
        onClick: onUp,
    },
    {
        id: 'down-btn',
        label: '',
        icon: React.createElement(DownIcon, null),
        onClick: onDown,
    },
    {
        id: 'delete-btn',
        label: '',
        icon: React.createElement(DeleteIcon, null),
        onClick: onDelete,
    },
    {
        id: 'cancel-btn',
        label: '',
        icon: React.createElement(CancelIcon, null),
        onClick: onCancel,
    },
];
//# sourceMappingURL=button-list.js.map